<template>
  <div class="v-home-take-care">
    <sheet>
      <accordion :data="homeTakeCare" />
<!--
<section-title title="A核心追蹤院區" />
      <paragraph :wording="serviceStatisticsACoreWording" />
<section-title title="B擴大追蹤院區" mt />
      <paragraph :wording="serviceStatisticsACoreWording" /> -->

      <to-prev-page routeName="diseases" />
    </sheet>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Accordion from '@/components/Global/Accordion.vue';
import { homeTakeCare } from '@/config/accordion';
import ToPrevPage from '@/components/Resources/ToPrevPage.vue';
// import Paragraph from '@/components/Global/Paragraph.vue';

export default defineComponent({
  name: 'HomeTakeCare',
  components: {
    Accordion,
    ToPrevPage,
    // Paragraph
  },
  setup() {
    return {
      homeTakeCare,
    };
  },
});
</script>
<style lang="scss" scoped></style>
